import PropTypes, { func } from "prop-types";
import React from "react";
import { Button, ButtonToolbar, Grid, Row, Col, Panel } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import Crew from "./Crew";
import JobTypeCapacities from "./JobTypeCapacities";
import TotalsColumn from "../shared/TotalsColumn";
import styles from "./DayView.less";

const DayView = ({
  className,
  date,
  entity,
  events,
  settings,
  eventsByCrew,
  jobTypes,
  onEditCrewClick,
  onLoadReportClick,
  onPrintWorkOrder,
  showTotalsRow,
  showUOMTotals,
  showJobCounts,
  includedItemTypes,
  showEstimatedQuantities,
  ...props
}) => {
  events = events.filter(function (e) {
    return e.evttype === settings.entity;
  });
  switch (settings.sortoption) {
    case "Date":
      events.sort(function (a, b) {
        if (a.startTime === null) {
          return 1;
        }
        if (b.startTime === null) {
          return -1;
        }
        if (a.startTime < b.startTime) return -1;
        if (a.startTime > b.startTime) return 1;
        else return 0;
      });
      break;
    case "Customer":
      events.sort(function (a, b) {
        if (a.customer && b.customer) {
          return a.customer.name.localeCompare(b.customer.name);
        } else if (a.datasheet && b.datasheet) {
          if (a.datasheet.customer && b.datasheet.customer) {
            return a.datasheet.customer.name.localeCompare(
              b.datasheet.customer.name
            );
          } else {
            return b.id - a.id;
          }
        } else if (a.job && b.job) {
          if (a.job.customer && b.job.customer) {
            return a.job.customer.name.localeCompare(b.job.customer.name);
          } else {
            return b.id - a.id;
          }
        } else if (a.bid && b.bid) {
          if (a.bid.customer && b.bid.customer) {
            return a.bid.customer.name.localeCompare(b.bid.customer.name);
          } else {
            return b.id - a.id;
          }
        } else {
          return b.id - a.id;
        }
      });

      break;
    case "Address":
      events.sort(function (a, b) {
        if (a.datasheet && b.datasheet) {
          if (
            a.datasheet.customer &&
            b.datasheet.customer &&
            a.datasheet.customer.address &&
            b.datasheet.customer.address
          ) {
            const compareState = conververNullToEmpty(
              a.datasheet.customer.address.state
            ).localeCompare(b.datasheet.customer.address.state);
            const compareCity = conververNullToEmpty(
              a.datasheet.customer.address.city
            ).localeCompare(b.datasheet.customer.address.city);
            const compareLine1 = conververNullToEmpty(
              a.datasheet.customer.address.line1
            ).localeCompare(b.datasheet.customer.address.line1);
            const compareLine2 = conververNullToEmpty(
              a.datasheet.customer.address.line2
            ).localeCompare(b.datasheet.customer.address.line2);
            return compareState || compareCity || compareLine1 || compareLine2;
          }
        } else if (a.customer && b.customer) {
          if (
            a.customer &&
            b.customer &&
            a.customer.address &&
            b.customer.address
          ) {
            const compareState = conververNullToEmpty(
              a.customer.address.state
            ).localeCompare(b.customer.address.state);
            const compareCity = conververNullToEmpty(
              a.customer.address.city
            ).localeCompare(b.customer.address.city);
            const compareLine1 = conververNullToEmpty(
              a.customer.address.line1
            ).localeCompare(b.customer.address.line1);
            const compareLine2 = conververNullToEmpty(
              a.customer.address.line2
            ).localeCompare(b.customer.address.line2);
            return compareState || compareCity || compareLine1 || compareLine2;
          }
        } else if (a.job && b.job && a.job.address && b.job.address) {
          const compareState = conververNullToEmpty(
            a.job.address.state
          ).localeCompare(b.job.address.state);
          const compareCity = conververNullToEmpty(
            a.job.address.city
          ).localeCompare(b.job.address.city);
          const compareLine1 = conververNullToEmpty(
            a.job.address.line1
          ).localeCompare(b.job.address.line1);
          const compareLine2 = conververNullToEmpty(
            a.job.address.line2
          ).localeCompare(b.job.address.line2);
          return compareState || compareCity || compareLine1 || compareLine2;
        } else if (a.bid && b.bid && a.bid.address && b.bid.address) {
          const compareState = conververNullToEmpty(
            a.bid.address.state
          ).localeCompare(b.bid.address.state);
          const compareCity = conververNullToEmpty(
            a.bid.address.city
          ).localeCompare(b.bid.address.city);
          const compareLine1 = conververNullToEmpty(
            a.bid.address.line1
          ).localeCompare(b.bid.address.line1);
          const compareLine2 = conververNullToEmpty(
            a.bid.address.line2
          ).localeCompare(b.bid.address.line2);
          return compareState || compareCity || compareLine1 || compareLine2;
        } else {
          return b.id - a.id;
        }
      });
      break;
  }

  function conververNullToEmpty(value) {
    if (value != null) return value;
    else return "";
  }

  return (
    <div className={className}>
      <ButtonToolbar>
        {entity === "purchaseOrders" && (
          <Button bsStyle="primary" onClick={onLoadReportClick}>
            <FontAwesome name="list-alt" /> Load Report
          </Button>
        )}
        {entity === "jobs" && (
          <Button
            bsStyle="primary"
            disabled={!events.some((e) => e.job)}
            onClick={() =>
              onPrintWorkOrder({
                eventId: events.filter((e) => e.job).map((e) => e.id),
                date: date.format("YYYY-MM-DD"),
              })
            }
          >
            <FontAwesome name="print" /> Print Work Orders
          </Button>
        )}
      </ButtonToolbar>
      <hr />
      <Grid>
        <Row>
          <Col xs={(showTotalsRow && settings.entity == "jobs" && 6) || 12}>
            <JobTypeCapacities jobTypes={jobTypes} events={events} />
          </Col>
          {showTotalsRow && settings.entity == "jobs" && (
            <Col xs={6}>
              <Panel bsStyle="default" defaultExpanded>
                <Panel.Toggle componentClass={Panel.Heading}>
                  <Panel.Title>Totals</Panel.Title>
                </Panel.Toggle>
                <Panel.Collapse>
                  <Panel.Body>
                    <TotalsColumn
                      date={date}
                      events={eventsByCrew}
                      showJobCounts={showJobCounts}
                      showUOMTotals={showUOMTotals}
                      includedItemTypes={includedItemTypes}
                      showEstimatedQuantities={showEstimatedQuantities}
                      currentDate={date}
                      styles={styles}
                    />
                  </Panel.Body>
                </Panel.Collapse>
              </Panel>
            </Col>
          )}
        </Row>
      </Grid>

      {eventsByCrew.map(({ active, crew, events }, i) => (
        <Crew
          {...props}
          active={active}
          crew={crew}
          date={date}
          events={events}
          key={i}
          onEditCrewClick={
            crew && onEditCrewClick ? () => onEditCrewClick(crew, events) : null
          }
          onPrintWorkOrder={onPrintWorkOrder}
        />
      ))}
    </div>
  );
};

DayView.propTypes = {
  entity: PropTypes.oneOf(["bids", "jobs", "purchaseOrders", "appointments"]),
  eventsByCrew: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool.isRequired,
      crew: PropTypes.object,
      events: PropTypes.arrayOf(PropTypes.object).isRequired,
    })
  ).isRequired,
  onEditCrewClick: PropTypes.func,
  onLoadReportClick: PropTypes.func,
  onPrintWorkOrder: PropTypes.func,
};

export default DayView;
